import React from 'react';

export const MarStateModal = {
  title: 'State, Province, or Prefecture',
  body: (
    <div>
      <p> The State, Province or Prefecture where the tsunami effects were observed.</p>
    </div>
  ),
};
